import React, { useState } from "react";
import "../CollegeFinder/FilterPanel.css"; // Reuse general filter panel styles
import CustomDropdown from "../CollegeFinder/CustomDropdown";

const CounsellorFilterPanel = ({ onApply }) => {
  // Filter Options
  const experienceOptions = ["0-2 Years", "2-5 Years", "5-10 Years", "10+ Years"];
  const specializationOptions = [
    "Career Guidance",
    "Study Abroad",
    "Profile Building",
    "Psychological Counselling",
    "Admission Counselling"
  ];
  const feesOptions = ["Free", "Under ₹500", "₹500 - ₹1000", "₹1000 - ₹2000", "Above ₹2000"];
  const ratingOptions = ["4.5 & above", "4.0 & above", "3.5 & above", "3.0 & above"];

  // Local state
  const [experience, setExperience] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [fees, setFees] = useState("");
  const [rating, setRating] = useState("");

  const clearAllFilters = () => {
    setExperience("");
    setSpecialization("");
    setFees("");
    setRating("");
  };

  const handleApply = () => {
    if (onApply) {
      onApply({
        experience,
        specialization,
        fees,
        rating
      });
    }
  };

  return (
    <div className="filter-main">
      <div className="filter-header">
        <h3>Filters</h3>
        <button className="remove-btn" onClick={clearAllFilters}>
          REMOVE ALL
        </button>
      </div>

      {/* Experience Filter */}
      <div className="filter-block">
        <label>Filter by Experience</label>
        <CustomDropdown
          options={experienceOptions}
          value={experience}
          onChange={setExperience}
          placeholder="Select Experience"
        />
      </div>

      {/* Specializations Filter */}
      <div className="filter-block">
        <label>Specializations</label>
        <CustomDropdown
          options={specializationOptions}
          value={specialization}
          onChange={setSpecialization}
          placeholder="Select Specialization"
        />
      </div>

      {/* Fees Filter */}
      <div className="filter-block">
        <label>Counselling Fees</label>
        <CustomDropdown
          options={feesOptions}
          value={fees}
          onChange={setFees}
          placeholder="Select Fees"
        />
      </div>

      {/* Rating Filter */}
      <div className="filter-block">
        <label>Rating</label>
        <CustomDropdown
          options={ratingOptions}
          value={rating}
          onChange={setRating}
          placeholder="Select Rating"
        />
      </div>

      <div className="apply-filter-parent">
        <button className="apply-filters-btn" onClick={handleApply}>
          APPLY FILTERS
        </button>
      </div>
    </div>
  );
};

export default CounsellorFilterPanel;
